import TodoList from './components/TodoList';
import { useState,useRef,useEffect } from 'react';
import { v4 as uuid } from 'uuid';

const LOCAL_TODOS_STORAGE_KEY = "#todos";

const mockData = [{
  id : uuid(),
  name:"Run a 10K",
  isCompleted: false
}, {
  id : uuid(),
  name:"Prepare Breakfast",
  isCompleted:false

}, {
  id : uuid(),
  name:"Work for 10 hours",
  isCompleted:false

}, {
  id : uuid(),
  name:"Go to sleep",
  isCompleted:false

},
{
  id : uuid(),
  name:"Try marking this task complete",
  isCompleted:false

}

];

function App() {

  const storedTodos = localStorage.getItem(LOCAL_TODOS_STORAGE_KEY)
  ? JSON.parse(localStorage.getItem(LOCAL_TODOS_STORAGE_KEY))
  : mockData; 

  const [todos, setTodos] = useState(storedTodos); 
  const newTaskInputRef = useRef();

  useEffect(() =>{

    localStorage.setItem(LOCAL_TODOS_STORAGE_KEY,JSON.stringify(todos));

  },[todos]);

  const addTodo = () => {


    const taskName = newTaskInputRef.current.value;
    newTaskInputRef.current.value = "";
    if(taskName === "") return ;

    setTodos((todos => [...todos,{id: uuid(),name:taskName,isCompleted:false}])) ;


  }

  const handleComplete = (id) => {

    let temp = [...todos];
    temp.find(item => item.id===id).isCompleted = true;
    setTodos(temp);
    setTimeout(()=>{
      setTodos((todos) =>{
        return todos.filter((todo) => todo.id !== id);
      })
    },500)

  }

  return (
    <div className="App">
      <div className="container">
        <div className="header-container">
            <h1 className='header'>Todo</h1>
            <form className="new-task-box" onSubmit={(e) =>{
              e.preventDefault();
              addTodo();
            }}>
              <input type="text" placeholder='Enter Task..' ref={newTaskInputRef}/>
              <div className="btn-container">              
                <button>Add Todo</button>
              </div>
            </form>
        </div>
        <TodoList todos = {todos} handleComplete={handleComplete} />
      </div>
    </div>
  );
}

export default App;
